import { DispatchCommentsErrors } from "../../../powerbroker/src/DispatchCommentsErrors";
import { MovementCallins } from "../../../powerbroker/src/MovementCallins";
import { RecentCallins } from "../../../powerbroker/src/RecentCallins";
import { CallinEntry } from "../CallinEntry";
import { ClearStop } from "../ClearStop";
import { MovementMap } from "../MovementMap";
import { SmsMessageDetails } from "../SmsMessageDetails";
import { DataSource, Label, Layout, Panel, Splitter, Switch, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutDispatchSlideout extends Layout {
    labelDistanceCaption: Label;
    labelEtaCaption: Label;
    labelLate: Label;
    labelNextStopCaption: Label;
    labelNextStopCity: Label;
    labelNextStopEtaDate: Label;
    labelNextStopEtaTime: Label;
    labelNextStopLoc: Label;
    labelNextStopMiles: Label;
    labelNextStopMilesUom: Label;
    labelNextStopState: Label;
    labelNextStopZip: Label;
    labelSmsMessagesHeader: Label;
    layoutCallinEntry: CallinEntry;
    layoutClearStop: ClearStop;
    layoutDispatchCommentsErrors: DispatchCommentsErrors;
    layoutMovementCallins: MovementCallins;
    layoutMovementMap: MovementMap;
    layoutRecentCallins: RecentCallins;
    layoutSmsMessages: SmsMessageDetails;
    panel10: Panel;
    panel11: Panel;
    panel9: Panel;
    panelEta: Panel;
    panelHeader: Panel;
    panelLate: Panel;
    panelMain: Panel;
    panelNextStop: Panel;
    panelNextStopCityState: Panel;
    sourceCallin: DataSource;
    sourceCarrierDriverMessage: DataSource;
    sourceComments: DataSource;
    sourceDispatch: DataSource;
    splitterTracking: Splitter;
    switchToggleLayout: Switch;
    tab1: Tab;
    tabCallin: Tab;
    tabSmsMessages: Tab;
    tabTracking: Tab;
    tabsetContent: Tabset;
    tabsetDispatch: Tabset;
    textboxBrokerageStatus: Textbox;
}
